<h3 class="eb-items-title d-lg-block d-xl-block">
  {{ 'checkoutProgress.orderItems' | cxTranslate }}
</h3>
<div class="cx-review-cart-item" *ngIf="order$ | async as order">
  <eb-cart-item-list [items]="order?.entries" [readonly]="true"></eb-cart-item-list>
</div>
<div class="eb-items-button">
  <button [routerLink]="{ cxRoute: 'orders' } | cxUrl">
    {{ 'checkoutProgress.goOrderHistory' | cxTranslate }}
  </button>
</div>
